import { Component } from "react";
import { Nav } from "react-bootstrap";
import ChevronListItem from "@/modules/shared/ui/ChevronListItem";

import type { ICategory } from "@/lib/backend/manufacturing2.generated.types";

type Props = {
    filter: string;
    plantFilter: string;
    selected: ICategory | null;
    items: ICategory[];
    handleItemClick: (item: ICategory) => void;
};

export default class CategoriesList extends Component<Props> {
    handleItemClick(item: ICategory) {
        // Ignore clicks for currently selected category
        if (item.code === this.props.selected?.code) {
            return;
        }

        // Handle parent's click events.
        this.props.handleItemClick(item);
    }

    includes(needle: string, item: ICategory): boolean {
        needle = needle.toLowerCase();
        if (needle.length === 0) return true;
        if (item.name.toLowerCase().indexOf(needle) > -1) return true;
        if (item.code.toLowerCase().indexOf(needle) > -1) return true;
        return false;
    }

    render() {
        const itemsList = this.props.items.map(item => {
            const is_active = this.props.selected?.code === item.code;

            if (!this.includes(this.props.filter, item)) return null;

            return (
                <ChevronListItem
                    key={item.id}
                    text={item.name}
                    subtext={item.code}
                    onClick={() => this.handleItemClick(item)}
                    is_active={is_active}
                />
            );
        });

        return (
            <Nav variant="tabs">
                <div className="nav-tabs-parent">{itemsList}</div>
            </Nav>
        );
    }
}
